import { CommonModule, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Notification {
  id: number;
  title: string;
  desc: string;
  time: string;
  date: string;
  read: boolean;
}

type NotificationTab = 'all' | 'unread';

@Component({
  selector: 'app-notification-panel',
  standalone: true,
  imports: [CommonModule, NgFor, NgIf, NgClass],
  templateUrl: './notification-panel.component.html',
  styleUrl: './notification-panel.component.scss'
})
export class NotificationPanelComponent {
  private _notifications: Notification[] = [];

  @Input()
  set notifications(value: Notification[] | null | undefined) {
    this._notifications = (value ?? []).map((notification) => ({ ...notification }));
  }
  get notifications(): Notification[] {
    return this._notifications;
  }

  @Output() notificationsChange = new EventEmitter<Notification[]>();
  @Output() readRequested = new EventEmitter<number>();
  @Output() deleteRequested = new EventEmitter<number>();
  @Output() markAllRequested = new EventEmitter<void>();

  activeTab: NotificationTab = 'all';

  get unreadCount(): number {
    return this._notifications.filter((notification) => !notification.read).length;
  }

  get filteredNotifications(): Notification[] {
    if (this.activeTab === 'unread') {
      return this._notifications.filter((notification) => !notification.read);
    }

    return this._notifications;
  }

  setTab(tab: NotificationTab): void {
    this.activeTab = tab;
  }

  markAsRead(notification: Notification): void {
    if (notification.read) {
      return;
    }

    notification.read = true;
    this.readRequested.emit(notification.id);
    this.emitChanges();
  }

  markAllRead(): void {
    if (this.unreadCount === 0) {
      return;
    }

    this._notifications = this._notifications.map((notification) => ({
      ...notification,
      read: true
    }));
    this.markAllRequested.emit();
    this.emitChanges();
  }

  deleteNotification(id: number): void {
    this._notifications = this._notifications.filter((notification) => notification.id !== id);
    this.deleteRequested.emit(id);
    this.emitChanges();
  }

  trackById(index: number, notification: Notification): number {
    return notification.id ?? index;
  }

  private emitChanges(): void {
    this.notificationsChange.emit(this._notifications.map((notification) => ({ ...notification })));
  }
}
